import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { Mutations } from '@shared/api';
import { API } from '@shared/types/api';

type DeleteEntitiesFunction = (ids: string[]) => Promise<true>;

export function useDeleteEntitiesMutation(workflowTemplateId: string): DeleteEntitiesFunction {
  const [deleteWorkflowEntity] = useMutation<
    API.DeleteWorkflowEntityMutation,
    API.DeleteWorkflowEntityMutationVariables
  >(Mutations.entity.deleteWorkflowEntity);
  const [deleteWorkflowEntities] = useMutation<
    API.DeleteWorkflowEntitiesMutation,
    API.DeleteWorkflowEntitiesMutationVariables
  >(Mutations.entity.deleteWorkflowEntities);

  return useCallback(
    async (ids: string[]) => {
      if (ids.length === 1) {
        const { data } = await deleteWorkflowEntity({
          variables: {
            input: {
              workflowTemplateId,
              id: ids[0],
            },
          },
        });
        const success = data?.deleteWorkflowEntity;
        if (success) {
          return success;
        }
        throw new Error('Failed to delete entity');
      } else {
        const { data } = await deleteWorkflowEntities({
          variables: {
            input: {
              workflowTemplateId,
              ids,
            },
          },
        });

        const success = data?.deleteWorkflowEntities;

        if (success) {
          return success;
        } else {
          throw new Error('Failed to delete entities');
        }
      }
    },
    [workflowTemplateId, deleteWorkflowEntity, deleteWorkflowEntities],
  );
}
